import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'smt-download-size-warning-dialog',
  templateUrl: './download-size-warning.dialog.html',
  styleUrls: ['./download-size-warning.dialog.scss'],
  host: { class: 'smt-download-size-warning-dialog' },
  encapsulation: ViewEncapsulation.None
})
export class DownloadSizeWarningDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { limit: number }) {}
}